import React, { useContext, useState, useEffect } from 'react';

import { ChipGroup, SelectableChip } from '@zooplus/ui-components';

import CartEventsContext from '../../common/contexts/CartEventsContext';
import LocResourcesContext from '../../common/contexts/LocResourcesContext';
import FiltersContext from '../contexts/FiltersContext';

const PetFilter = ({}) => {
  const GLOBAL_PREFIX = 'loy-bp-rws-overview';

  const {
    selectedPetTypes,
    onSelectPetTypes,
    PetTypes,
    selectDonationArticles,
    onSelectDonationArticles,
  } = useContext(FiltersContext);
  const { donationArticles } = useContext(CartEventsContext);
  const { onFormatLocale } = useContext(LocResourcesContext);

  const [petSelectedState, setPetSelectedState] = useState<string[]>(selectedPetTypes ?? []);

  const isSelected = (petKey: string): boolean => {
    return selectedPetTypes?.includes(petKey) ?? false;
  };

  const onAddPet = (petKey: string): void => {
    setPetSelectedState([...petSelectedState, petKey]);
  };

  const onRemovePet = (petKey: string): void => {
    setPetSelectedState(petSelectedState.filter((item) => item !== petKey));
  };

  useEffect(() => {
    setPetSelectedState(selectedPetTypes ?? []);
  }, [selectedPetTypes]);

  useEffect(() => {
    onSelectPetTypes?.(petSelectedState);
  }, [petSelectedState]);

  return (
    <React.Fragment>
      <div>
        <label className={`${GLOBAL_PREFIX}_filter__pets--title`}>{onFormatLocale?.('loy.rewards.shop.filter.shop')}</label>
      </div>
      <div className={`${GLOBAL_PREFIX}_filter__pets`}>
        <ChipGroup className="pp-mb-m">
          {PetTypes?.map((PetType) => {
            return (
              <SelectableChip
                key={PetType.item.petKey}
                inputId={PetType.item.title}
                label={`${PetType.item.title} (${PetType.numberOfArticles})`}
                selected={isSelected(PetType.item.title)}
                onClick={() =>
                  isSelected(PetType.item.title)
                    ? onRemovePet(PetType.item.title)
                    : onAddPet(PetType.item.title)
                }
              />
            );
          })}
          {donationArticles && donationArticles.length > 0 && (
            <SelectableChip
              inputId={onFormatLocale?.('loy.rewards.shop.filter.donate') ?? ''}
              label={`${onFormatLocale?.('loy.rewards.shop.filter.donate')} (${donationArticles?.length})`}
              selected={selectDonationArticles}
              onClick={() =>
                selectDonationArticles
                  ? onSelectDonationArticles?.(false)
                  : onSelectDonationArticles?.(true)
              }
            />
          )}
        </ChipGroup>
      </div>
    </React.Fragment>
  );
};

export default PetFilter;
